import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import {CalendarModule, FileUploadModule, InputTextModule, DragDropModule, RadioButtonModule} from 'primeng/primeng';

import { CadensSharedModule } from '../../shared';
import { CadensAdminModule } from '../../admin/admin.module';

import { EspaceCandidatComponent } from './espaceCandidat.component';

import { espaceCandidatRoute } from './espaceCandidat.route';
import {ConfirmationService} from 'primeng/components/common/api';
import {ConfirmDialogModule} from 'primeng/components/confirmdialog/confirmdialog';

let ENTITY_STATES = [
    ...espaceCandidatRoute
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensAdminModule,
        FileUploadModule,
        InputTextModule,
        CalendarModule,
        ConfirmDialogModule,
        DragDropModule,
        RouterModule.forRoot(ENTITY_STATES, {useHash: true}),
        RadioButtonModule
    ],
    declarations: [
        EspaceCandidatComponent
    ],
    entryComponents: [
        EspaceCandidatComponent
    ],
    providers: [
        ConfirmationService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensEspaceCandidatModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/espaceCandidat/espaceCandidat.module.ts